import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import AggregatedLogger from "../../observability/AggregatedLogger/AggregatedLogger";

const ErrorMessage = styled.h1`
  height: 100vh;
  line-height: 100vh;
  width: 100vw;
  font-family: sans-serif;
  font-weight: 200;
  text-align: center;
  padding: 0;
  margin: 0;
`;

interface Props {
  message: string;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<PropsWithChildren<Props>, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    AggregatedLogger.error("Something went wrong.");
    return { hasError: true };
  }

  public render() {
    const { hasError } = this.state;
    const { children, message } = this.props;
    if (hasError) {
      return (
        <ErrorMessage data-testid="error-boundary">{message}</ErrorMessage>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
